import { Http } from 'services/http';
import { API_CHAT_URL } from 'consts/common.const';

export const getSettingChat = () => {
  return Http.request({
    method: 'GET',
    url: `${API_CHAT_URL}/common/get-setting`,
  });
};
